module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-1a6584e4.png";